/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Web_FcInputs */

const en_fc_cmp_web_fc = /** @type {(inputs: Fc_Cmp_Web_FcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes (WebAssembly)`)
};

/**
* | output |
* | --- |
* | "Yes (WebAssembly)" |
*
* @param {Fc_Cmp_Web_FcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_web_fc = /** @type {((inputs?: Fc_Cmp_Web_FcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Web_FcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_web_fc(inputs)
});
export { fc_cmp_web_fc as "fc.cmp.web.fc" }